
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 28a3 3 0 100-6 3 3 0 000 6z","stroke":"#fff","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9 7h12a4 4 0 110 8H9a5 5 0 000 10h13","stroke":"#fff","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6 10a3 3 0 100-6 3 3 0 000 6z","stroke":"#56BFC7","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    